"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseError = exports.isAtlasEngineError = void 0;
const errorClasses = require("./index");
function isAtlasEngineError(error) {
    return (error instanceof Error) && error.isAtlasEngineError === true;
}
exports.isAtlasEngineError = isAtlasEngineError;
class BaseError extends Error {
    constructor(code, message) {
        var _a;
        super(message);
        this.isAtlasEngineError = true;
        this.code = code;
        this.name = this.constructor.name;
        const captureStackTraceMethodAvailable = Error.captureStackTrace !== undefined;
        if (captureStackTraceMethodAvailable) {
            // For NodeJS and Chrome
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            // Fallback for others like Firefox, IE 10+, Safari etc.
            this.stack = (_a = (new Error()).stack) !== null && _a !== void 0 ? _a : '';
        }
    }
    static deserialize(serializedError, reviverFunction) {
        let errorInfo;
        try {
            errorInfo = JSON.parse(serializedError, reviverFunction);
        }
        catch (error) {
            throw new Error(`Error while deserializing error: Couldn't parse string: ${error.message}`);
        }
        const errorClassUndefined = errorInfo.errorClassName === undefined;
        const codeUndefined = errorInfo.code === undefined;
        const callStackUndefined = errorInfo.callStack === undefined;
        const structureIsIncorrect = errorClassUndefined || codeUndefined || callStackUndefined;
        if (structureIsIncorrect) {
            throw new Error('Error while deserializing error: Serialized object has an incompatible structure.');
        }
        const errorClassIsUnknown = errorClasses[errorInfo.errorClassName] === undefined;
        if (errorClassIsUnknown) {
            throw new Error(`Error while deserializing error: ${errorInfo.errorClassName} is not a known error type.`);
        }
        const errorClass = new errorClasses[errorInfo.errorClassName](errorInfo.message);
        errorClass.stack = errorInfo.callStack;
        errorClass.additionalInformation = errorInfo.additionalInformation;
        return errorClass;
    }
    serialize() {
        return JSON.stringify({
            errorClassName: this.constructor.name,
            code: this.code,
            message: this.message,
            callStack: this.stack,
            additionalInformation: this.additionalInformation,
        });
    }
}
exports.BaseError = BaseError;
//# sourceMappingURL=BaseError.js.map